import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map, Observable, of} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PaymentErrorService {
  private messages: { [key: string]: string } = {};
  private isTimerActive = false;
  private clearTimeoutId: any = null;

  constructor(private readonly http: HttpClient) {
  }

  loadMessages(): Observable<{ [key: string]: string }> {
    if (Object.keys(this.messages).length > 0) {
      return of(this.messages);
    }

    return this.http.get<{ PAYMENT_MESSAGES?: { [key: string]: string } }>('assets/i18n/credit-card-payment-error-message.json').pipe(
      map((data) => {
        this.messages = data?.PAYMENT_MESSAGES ?? {};
        return this.messages;
      })
    );
  }

  getMessage(errorCode: string, status: string): Observable<string> {
    return this.loadMessages().pipe(
      map(messages => (messages?.[errorCode] ?? status))
    );
  }

  clearMessagesWithDelay(
    clearCallback: () => void,
    delay: number = 15000 // default to 15 seconds
  ): void {
    if (this.isTimerActive) {
      return;
    }

    this.isTimerActive = true;
    this.clearTimeoutId = setTimeout(() => {
      clearCallback();
      this.isTimerActive = false;
      this.clearTimeoutId = null;
    }, delay);
  }

  resetTimer() {
    if (this.clearTimeoutId) {
      clearTimeout(this.clearTimeoutId);
      this.clearTimeoutId = null;
      this.isTimerActive = false;
    }
  }
}
